import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { User } from "../../types/user";
import Role from "../../enum/Role.enum";

export interface UserState {
  user: User | null;
  roles: string[];
  isAdmin: boolean;
}

const initialState: UserState = {
  user: null,
  roles: [],
  isAdmin: false,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<User>) {
      const user = action.payload;
      state.user = user;
      state.roles = user.privileges ? user.privileges : [];
      state.isAdmin = state.roles?.includes(Role.AGENT_ADMIN);
    },
    resetUser: () => initialState,
  },
});

export const { setUser, resetUser } = userSlice.actions;

export default userSlice;
